import { render, staticRenderFns } from "./HbHeader.vue?vue&type=template&id=72487095&scoped=true&"
import script from "./HbHeader.vue?vue&type=script&lang=js&"
export * from "./HbHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72487095",
  null
  
)

export default component.exports